import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7bc8b14a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7bc8b14a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8b14a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/app/jenkins/data/workspace/TEST测试环境/xcommunity-test/shenyang-xcommunity-web-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc8b14a')) {
      api.createRecord('7bc8b14a', component.options)
    } else {
      api.reload('7bc8b14a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7bc8b14a&scoped=true", function () {
      api.rerender('7bc8b14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DYImageUpload/index.vue"
export default component.exports